
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gv41m2Qp_45uBAzOHsP0BrrnOz8Xr86lsbLLi80ZdMAG5kMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index3gii0ec1c_p0RqrX3PE_CjBia6_45_45pc_QnmFClzSMx_45AMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchGpuW4q5HJw_yuowiudSrUrSaDwi1C86nTlAftnW5NOkMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexbph_iAQlA8_45KnFfYaB4H6F6R1p3g0LpSLuiAQ895zk4Meta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_939H070HbpwQVomvBvc3CEC6ZKFApZjARGyqGPfVLH7TQMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexgQUKhEcp7HOW1tFoVobzAq4kOSn_qi9iO2zEnWlRrWUMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93hVrLasZE43likFjnKnsOmAw5ebZZlesIc4FdzKK3KF4Meta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index_oz4RyHOGeICvdZmUwcaWNZ1laftgndPH9GFw2Ko_45yUMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93SMjXFhw281J5J8bGqiBLj52WpXN5kD1O90ecvlCQoeUMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexohqZfNeTdJ6K3jpvy8ysAcTtAFXfjfgj9MF4g_45zvgXUMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexcb0RtbUBRkdeQgT2o_Djvg5nFyMMDXV90regpTQmziAMeta } from "/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexgQUKhEcp7HOW1tFoVobzAq4kOSn_qi9iO2zEnWlRrWUMeta || {},
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index_oz4RyHOGeICvdZmUwcaWNZ1laftgndPH9GFw2Ko_45yUMeta || {},
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexohqZfNeTdJ6K3jpvy8ysAcTtAFXfjfgj9MF4g_45zvgXUMeta || {},
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexcb0RtbUBRkdeQgT2o_Djvg5nFyMMDXV90regpTQmziAMeta || {},
    component: () => import("/codebuild/output/src579911969/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]